import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './Theme';
import { GlobalStyles } from './GlobalStyles';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import Trust from './components/Trust';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Gallery from './components/Gallery';
import WhyChooseUs from './components/WhyChooseUs';
import Quote from './components/Quote';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ChatNow from './components/Chatnow';


function App() {
  const [isArabic, setIsArabic] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles isArabic={isArabic} />
      <Header isArabic={isArabic} setIsArabic={setIsArabic} />
      <HeroBanner />
      <Trust />
      <AboutUs />
      <Services />  
      <Gallery />
      <WhyChooseUs />
      <Quote />
      <Footer />
      <ChatNow />
    <BackToTop />
      {/* Rest of your sections will go here */}
    </ThemeProvider>
  );
}

export default App;